const userState = {
    auth: null,
    token: null,
    tokenType: null,
    expiresIn: null,
    role_name: null,
    permissions: [],
    loginLoading: false
}

const quotationState = {
    quotations: [],
    quotationsLoading: false,
    newQuotation: {
        parent_quote: null,
        quote_number: null,
        is_draft: null,
        quote_name: null,
        customer_id: null,
        customer: null,
        sale_rep: null,
        files_attached: [],
        notes: [""],
        products: [
            {
                product_id: null,
                product: null,
                product_num: null,
                name: null,
                description: null,
                quantity_unit: 'bags',
                is_master_product_modify: false,
                tiers: [
                    {
                        tier: null,
                        sku: null
                    },
                    {
                        tier: null,
                        sku: null
                    },
                    {
                        tier: null,
                        sku: null
                    }
                ],
            }
        ],
    },
    priceCalculation: {
        quote_id: null,
        price_notes: null,
        products:[
            {
                product_id: null,
                description: null,
                product_name: null,
                quantity_unit: null,
                vendors: [
                    {
                        vendor_id: null,
                        contact_id: null,
                        company_name: null,
                        contact_name: null,
                        quote_tiers: [
                            {
                                tier_value: null,
                                peices: null,
                                vendor_cost: null,
                                rate: null,
                                selling: null,
                                cost: null,
                                profit: null,
                                total_amt: null,
                                notes: null,
                                price: 1,
                            }
                        ],
                        primary_tiers: [
                            {
                                tier_value: null,
                                peices: null,
                                vendor_cost: null,
                                rate: null,
                                selling: null,
                                cost: null,
                                profit: null,
                                total_amt: null,
                                notes: null,
                                price: 1,
                            }
                        ],
                        rest_tiers: [
                            {
                                tier_value: null,
                                peices: null,
                                vendor_cost: null,
                                rate: null,
                                selling: null,
                                cost: null,
                                profit: null,
                                total_amt: null,
                                notes: null,
                                price: null,
                            }
                        ],
                        all_tiers: [
                            {
                                tier_value: null,
                                peices: null,
                                vendor_cost: null,
                                rate: null,
                                selling: null,
                                cost: null,
                                profit: null,
                                total_amt: null,
                                notes: null,
                                price: null,
                            }
                        ]
                    }
                ]
            }
        ],
    },
    filter: {
        isListView: true,
        showFilters: false,
        filterData: {
            search_filter: null,
            date_filter: null,
            user_id: null,
            status: null,
            tab: null,
            customer_id: null,
            date_range: null,
            type: null,
            cus_id: null,
            start: null,
            end: null,
            customer_user: null
        },
    }
}

const customerState = {
    customers: [],
    customersLoading: false
}

const salesOrderState = {
    orders: [],
    menuItems:[],
    ordersLoading: false,
    maxNumOfShipToAddress: 3,
    newOrder: {
        id: null,
        parent_id: null,
        is_draft: 0,
        is_stocking: 0,
        stocking_terms: null,
        warehouses: [],
        customerWarehouses: [],
        billTo: [],
        customer_id: null,
        sales_rep_id: null,
        order_number: null,
        order_date: null,
        customer_terms: null,
        customer_po: null,
        eta: null,
        fob: null,
        notes: null,
        customer_notes: null,
        quotations: [],
        customer: {
            quotations_after_sent_to_customer: []
        },
        products:[],
        selectedProducts: []
    },
    showFilters: false,
    filterData: {
        search_filter: null,
        sale_user_id: null,
        search_customer_id: null,
        search_added_user_id: null,
        search_by_date: null,
        status_search: null,
        date_range: null,
        label_id: null
    }
}
const purchaseOrderState = {
    orders: [],
    ordersLoading: false,
    menuItems:[],
    newOrder: {
        order_id: null,
        vendor_id: null,
        is_draft : 0,
        po_number: null,
        order_date: null,
        vendor_terms: null,
        vendor_po: null,
        vendor_fob: null,
        eta: null,
        delivery_date: null,
        notes: null,
        vendor_notes: null,
        po_status_id: 1,
        products:[],
        vendor: null,
        selectedProducts: [],
        quote_num: null
    },
    showFilters: false,
    filterData: {
        purchase_search: null,
        search_saleuser_id: null,
        search_vendor_id: null,
        search_added_user_id: null,
        search_by_date: null,
        search_status_Id: null,
        date_range: null,
        label_id: null
    }
}

const taskState = {
    showFilters: false,
    filterData: {
        search_filter: null,
        search_assigns: null,
        order_type: 'so',
        order_id: null,
        order: null,
        search_by_date: null,
        status: null,
        date_range: null
    }
}

const reminderState = {
    showFilters: false,
    filterData: {
        search_filter: null,
        search_assigns: null,
        order_type: 'so',
        order_id: null,
        order: null,
        search_by_date: null,
        status: null,
        date_range: null
    }
}

const commonState = {
    errorMessage: null,
    successMessage: null,
    commonErrors: [],
    loading: false,
    productsLoading: false,
    quoteProductsLoading: false,
    settings: null,
    dashboardTarget: 'so',
    dashboardTargetUser: 'customer',
    carriers: [],
    vendorFilter: {
        showFilters: false,
        filterForm: {
            search_filter: null,
            status_filter: '',
            vendor_bag: [],
            country_id: [],
            bag_id:[],
        },
    },
    exportFile: null
}

const backState = {
    loading:false
}
const getDefaultState = () => {
    return {
        userState: userState,
        quotationState: quotationState,
        customerState: customerState,
        salesOrderState: salesOrderState,
        purchaseOrderState: purchaseOrderState,
        taskState: taskState,
        reminderState: reminderState,
        commonState: commonState,
    }
}

// initial state
const initialState = getDefaultState()

export default {
    initialState,
    userState,
    quotationState,
    commonState,
    customerState,
    salesOrderState,
    purchaseOrderState,
    taskState,
    reminderState,
    backState
}
